document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('koji-command-center');
  const screenArea = document.getElementById('koji-cc-monitor-screen');
  const playerContainer = document.getElementById('koji-cc-twitch-player');
  const activateBtn = document.getElementById('koji-cc-activate-twitch');

  // ==========================================
  // 1. EFFETTO HACKER SCRAMBLE SUI TITOLI
  // ==========================================
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
  const scrambleElements = document.querySelectorAll('.koji-scramble');

  scrambleElements.forEach(el => {
    // Salviamo l'HTML originale per preservare i tag <br> di Shopify
    const originalHTML = el.innerHTML;
    const originalText = el.innerText;
    
    el.addEventListener('mouseenter', e => {
      let iteration = 0;
      clearInterval(el.interval);
      
      el.interval = setInterval(() => {
        el.innerText = originalText.split("").map((char, index) => {
          if(index < iteration) return originalText[index];
          if(char.trim() === '') return char; // Salta spazi e a capo visivi
          return letters[Math.floor(Math.random() * letters.length)];
        }).join("");
        
        if(iteration >= originalText.length) {
          clearInterval(el.interval);
          el.innerHTML = originalHTML; // Ripristina l'HTML reale a fine animazione
        }
        iteration += 1/2; // Velocità di decodifica
      }, 30);
    });
  });

  // ==========================================
  // 2. SPOTLIGHT (LUCE CHE SEGUE IL MOUSE)
  // ==========================================
  const glowCards = document.querySelectorAll('.koji-glow-card');
  
  glowCards.forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      card.style.setProperty('--mouse-x', `${x}px`);
      card.style.setProperty('--mouse-y', `${y}px`);
    });
  });

  // ==========================================
  // 3. TWITCH RADAR E LAZY LOADING PLAYER
  // ==========================================
  if (!playerContainer || !wrapper) return;

  const channel = playerContainer.getAttribute('data-channel');
  const parentHost = playerContainer.getAttribute('data-parent');
  const isManualLive = wrapper.classList.contains('is-live-mode');

  // Il controllo contatta decapi.me (servizio di terzi), che vede l'IP del visitatore. Per limitare l'esposizione:
  // parte solo quando questa sezione è davvero visibile, solo a scheda attiva, senza cookie e senza referrer.
  // Metti true qui sotto per controllare SOLO dopo il clic su "Avvia trasmissione" (nessuna chiamata a decapi.me prima del clic;
  // in quel caso il cambio automatico in modalità LIVE avviene solo dopo il clic).
  const LIVE_CHECK_ON_CLICK_ONLY = false;
  const CHANNEL_OK = /^[A-Za-z0-9_]{1,25}$/.test(channel || '');
  let liveTimer = null;

  function checkLiveStatus() {
    if (isManualLive || !CHANNEL_OK || document.hidden) return; 

    const ctl = window.AbortController ? new AbortController() : null;
    const killer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);

    fetch('https://decapi.me/twitch/uptime/' + encodeURIComponent(channel), {
      signal: ctl ? ctl.signal : undefined,
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      cache: 'no-store'
    })
      .then(res => res.text())
      .then(text => {
        clearTimeout(killer);
        text = String(text || '').slice(0, 200);
        // In diretta solo se la risposta indica da quanto tempo è online (ore, minuti, secondi): un messaggio d'errore non conta
        const isLive = !/offline/i.test(text) && /\b(second|minute|hour|day)s?\b/i.test(text);
        if (isLive) {
          wrapper.classList.add('is-live-mode');
        } else {
          wrapper.classList.remove('is-live-mode');
        }
      })
      .catch(e => { clearTimeout(killer); console.log('Radar Koji: Interferenza segnale Twitch.'); });
  }

  function startLivePolling() {
    if (liveTimer || isManualLive) return;
    checkLiveStatus();
    // Ricontrolla ogni 60 secondi
    liveTimer = setInterval(checkLiveStatus, 60000);
  }

  if (!LIVE_CHECK_ON_CLICK_ONLY) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          startLivePolling();
          io.disconnect();
        }
      }, { rootMargin: '200px' });
      io.observe(wrapper);
    } else {
      startLivePolling();
    }
  }

  if (!activateBtn) return;

  activateBtn.addEventListener('click', function(e) {
    e.preventDefault();

    if (LIVE_CHECK_ON_CLICK_ONLY) startLivePolling();
    
    activateBtn.innerHTML = '<span class="koji-play-icon">⏳</span><span>COLLEGAMENTO...</span>';
    activateBtn.style.opacity = '0.7';
    activateBtn.style.pointerEvents = 'none';

    if (typeof Twitch !== 'undefined') {
      initTwitchPlayer();
    } else {
      const script = document.createElement('script');
      script.src = 'https://player.twitch.tv/js/embed/v1.js';
      script.onload = () => initTwitchPlayer();
      document.head.appendChild(script);
    }
  });

  function initTwitchPlayer() {
    if (screenArea) screenArea.classList.add('is-loaded');

    const player = new Twitch.Player('koji-cc-twitch-player', {
      channel: channel,
      parent: [parentHost],
      width: '100%',
      height: '100%',
      autoplay: true,
      muted: false
    });

    player.addEventListener(Twitch.Player.ONLINE, () => {
      if (wrapper) wrapper.classList.add('is-live-mode');
    });

    player.addEventListener(Twitch.Player.OFFLINE, () => {
      if (wrapper && !isManualLive) wrapper.classList.remove('is-live-mode');
    });
  }
});